export default __webpack_public_path__ + "static/media/lds-logo_ht.05ab7ca253fc8c99.svg";